import { getSubdomainSlug } from '@/utils/subdomain'
import { getDefaultAppLocale, getStoredAppLocale } from '@/config/app-locales'

/** True when the shell is the marketing site home (not a restaurant subdomain, path `/`). */
export function isBootstrapMarketingLanding() {
  if (typeof window === 'undefined') return false
  if (getSubdomainSlug()) return false
  const p = window.location.pathname || '/'
  return p === '/' || p === ''
}

/**
 * True if the browser reports Spanish as a preferred language (es, es-ES, es-MX, es-419, …).
 * Keep Spanish detection in sync with the inline script in `index.html` (static shell is only shown on marketing `/`).
 */
function systemLanguagePrefersSpanish() {
  if (typeof navigator === 'undefined') return false
  /** @type {string[]} */
  const candidates = []
  if (Array.isArray(navigator.languages)) {
    for (const l of navigator.languages) {
      if (typeof l === 'string') candidates.push(l)
    }
  }
  if (typeof navigator.language === 'string' && navigator.language) {
    candidates.push(navigator.language)
  }
  for (const raw of candidates) {
    const tag = raw.trim().toLowerCase()
    if (tag === 'es' || tag.startsWith('es-')) return true
  }
  return false
}

/**
 * Initial locale before Vue mounts. User-chosen locale (localStorage) always wins.
 * On the marketing landing only: Spanish if the system/browser language is es*, otherwise English.
 * Other routes use VITE_DEFAULT_LOCALE.
 *
 * @param {string|null} storedLocale - from getStoredAppLocale()
 */
export function getBootstrapLocale(storedLocale) {
  if (storedLocale) return storedLocale
  if (!isBootstrapMarketingLanding()) return getDefaultAppLocale()
  if (import.meta.env.VITE_DISABLE_LANDING_AUTO_LOCALE === 'true') return getDefaultAppLocale()
  // Back-compat with previous env name (geo-based feature)
  if (import.meta.env.VITE_DISABLE_LANDING_GEO_LOCALE === 'true') return getDefaultAppLocale()

  return systemLanguagePrefersSpanish() ? 'es' : 'en'
}
